module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'nav-list2': _vm.type == 2 || _vm.type == 1, 'nav-list3': _vm.type == 3, 'nav-list1': _vm.type == 1
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('router-link', {
      key: item.item_id,
      staticClass: "list  vux-1px-b",
      attrs: {
        "to": {
          name: 'detail',
          params: {
            id: item.item_id
          }
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.image_default_id,
        "default-src": "static/placeholder.png",
        "container": "#vux_view_box_body"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-l "
    }, [_c('h1', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("￥" + _vm._s(item.price))])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e8a7438"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeTopNav/MList.vue
// module id = 536
// module chunks = 0